import * as Sentry from '@sentry/browser';

Sentry.init({ dsn: 'https://5bd0c82cac4e4451a9f099b6d81cf4e6@sentry.pludoni.com/24', release: window.SENTRY_RELEASE_NAME, environment: 'production' });
// nur zum Testen in globale Variable stecken
window.Sentry = Sentry
